import { Svg } from "common/assets";
import { Fade } from "react-awesome-reveal";
import { products } from "./data";
import { ProductItem } from "./ProductItem";
import {
  IconEllipse,
  StyledItemProduct,
  StyledItemProductName,
  StyledItemProductPrice,
  StyledListProducts,
  StyledNameWrapper,
  StyledSpan,
} from "./styled";
import { TProduct } from "./types";

export const Products = () => {
  
  return (
    <StyledListProducts>
      <Fade
        cascade
        triggerOnce
        direction="right"
        delay={1500}
        duration={400}
        damping={0.5}
      >
        {products.map((product, index: number) => (
          <ProductItem product={product} key={index} />
        ))}
      </Fade>
    </StyledListProducts>
  );
};
